import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import Icon from '@cotyorg/ccx-atoms/Icon';
import { analyticsDecorator } from '../utils';

const DEFAULT_QTY = 10;

const ShoppingBagQuantitySelector = ({ product, updateBasketItemQuantity }) => {
  const productQty = R.prop('quantity', product);
  const ean = R.prop('ean', product);
  const quantityArr =
    productQty > DEFAULT_QTY
      ? [...Array(productQty + 1)]
      : [...Array(DEFAULT_QTY)];

  return (
    <div className="product__quantity select-wrapper">
      <select
        className="select"
        value={productQty}
        data-ean={ean}
        onChange={(e) =>
          updateBasketItemQuantity(
            ean,
            parseInt(e.target.value, 10),
            productQty
          )
        }
        {...analyticsDecorator('update-quantity', 'select')}
      >
        {quantityArr.map((item, index) => (
          <option value={index} key={uuid()}>
            {index}
          </option>
        ))}
      </select>
      <Icon
        iconExtraClass="select__chevron"
        iconSrc="/ccx-files/assets/chevron-down.svg"
      />
    </div>
  );
};

ShoppingBagQuantitySelector.propTypes = {
  product: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ),
  updateBasketItemQuantity: PropTypes.func,
};

export default ShoppingBagQuantitySelector;
